import { render } from "./EditItem.vue?vue&type=template&id=6c5c9a75&scoped=true"
import script from "./EditItem.vue?vue&type=script&lang=js"
export * from "./EditItem.vue?vue&type=script&lang=js"

import "./EditItem.vue?vue&type=style&index=0&id=6c5c9a75&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5c9a75"]])

export default __exports__